var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from 'react';
import { Context } from '../context';
function IconMessageReadComponent(props, ref) {
    var prefixFromContext = useContext(Context).prefix;
    var _a = props.className, className = _a === void 0 ? '' : _a, prefixFromProps = props.prefix, _b = props.width, width = _b === void 0 ? '1em' : _b, _c = props.height, height = _c === void 0 ? '1em' : _c, _d = props.useCurrentColor, useCurrentColor = _d === void 0 ? true : _d, spin = props.spin, rest = __rest(props, ["className", "prefix", "width", "height", "useCurrentColor", "spin"]);
    var prefix = prefixFromProps || prefixFromContext || 'mag-seller';
    var loadingKls = spin ? " ".concat(prefix, "-icon-loading") : '';
    return React.createElement("svg", __assign({ className: "".concat(prefix, "-icon ").concat(prefix, "-icon-MessageRead").concat(loadingKls, " ").concat(className), width: width, height: height, viewBox: "0 0 16 17", fill: useCurrentColor ? 'currentColor' : '#000', xmlns: "http://www.w3.org/2000/svg" }, rest, { ref: ref }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.4311 2.47603C11.2619 2.33403 11.0096 2.3561 10.8676 2.52533L4.05063 10.4577 1.25964 7.66676C1.10343 7.51055.850168 7.51055.693958 7.66676L.198983 8.16173C.0427731 8.31794.0427735 8.57121.198983 8.72742.591265 9.1197 3.36651 12.0726 3.7 12.3525 3.86923 12.4945 4.118 12.4724 4.26 12.3032L12.0167 3.48951C12.1587 3.32028 12.1366 3.06798 11.9674 2.92598L11.4311 2.47603zM15.229 3.47603C15.0598 3.33403 14.8075 3.3561 14.6655 3.52533L8.84848 10.4577 8.05749 9.66676C7.90128 9.51055 7.64802 9.51055 7.49181 9.66676L6.99683 10.1617C6.84062 10.3179 6.79785 10.5 6.99683 10.7274 7.26427 11.033 8.24757 12.1425 8.49785 12.3525 8.66708 12.4945 8.91585 12.4724 9.05785 12.3032L15.8145 4.48951C15.9565 4.32028 15.9345 4.06798 15.7652 3.92598L15.229 3.47603z" }));
}
var IconMessageRead = React.forwardRef(IconMessageReadComponent);
export default IconMessageRead;
